<script lang="ts" setup>
	import type { ClassNameValue } from 'tailwind-merge'
	import type { UserBioContext } from '~/components/My-Cover/staff-properties/bio.vue'

	const { className = 'md:max-w-[256px]' } = defineProps<{
		bio: UserBioContext
		employeeName: string
		loading?: boolean
		isdeactivated?: boolean
		cardClass?: string
		className?: ClassNameValue
		isPendingTermination?: boolean
	}>()
	defineEmits<{
		(arg: 'deactivate'): void
		(arg: 'activate'): void
	}>()
</script>

<template>
	<shared-card
		:loading="loading"
		:loader-width="256"
		:loader-height="600"
		loader-class="!hidden sm:!block"
		:wrapper-class="cn(className, `sm:border border-gray-100`)"
		:default-class="cardClass"
		:ui="{ container: 'md:px-3' }"
	>
		<my-cover-staff-properties-bio
			:details="bio"
			class=""
			:name="employeeName"
			image-wrapper-class="border-purple-500 bg-purple-25 flex justify-center items-center"
		>
			<template #subName>
				<slot name="subName" />
			</template>
			<template #subTitle>
				<span v-show="isdeactivated" class="text-xs tracking-wide text-error-500">deactivated</span>
			</template>
			<template #list-item>
				<slot name="footer" />
			</template>
		</my-cover-staff-properties-bio>
	</shared-card>
</template>
